/**
 * @generated SignedSource<<6ebbc302b5516c8a03f61e7e4b4458f9>>
 * @relayHash 5fa94de1e3b24e88ef6e4f0019453e8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7d1a78d294006aa37d612689edca4c05623604c2e2c8a292afd1670988b065c6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessTimelineEmbedQuery } from './src_jiraBusinessTimelineEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessTimelineEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7d1a78d294006aa37d612689edca4c05623604c2e2c8a292afd1670988b065c6",
    "metadata": {},
    "name": "src_jiraBusinessTimelineEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
